import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Button, Col, notification, Row, Skeleton } from 'antd';
import moment from 'moment';

// Components
import VAAnalysisLoader from './VAAnalysisLoader';
import VAMissingFields from './VAMissingFields';
import VACaseDetails from './VACaseDetails';
import VACaseDetailsAnalyzed from './VACaseDetailsAnalyzed';
import { XThemeVoiceAssTableCard } from '../../VoiceAssistanceStyle';

// Actions
import {
	analyseCoverageApi,
	analyseCoverageReset,
} from '../../../../actions/analyseCoverageAction';
import {
	reviseCoverageApi,
	reviseCoverageReset,
} from '../../../../actions/reviseCoverageAction';
import {
	getAnalysisApi,
	getAnalysisReset,
} from '../../../../actions/getAnalysisAction';
import {
	sendFeedbackApi,
	sendFeedbackReset,
} from '../../../../actions/sendFeedbackAction';
import {
	getAnalysisStatusApi,
	getAnalysisStatusReset,
} from '../../../../actions/getAnalysisStatusAction';
import { editCaseApi, editCaseReset } from '../../../../actions/editCaseAction';
import { XForm } from '../../../../styles/GlobalStyle';
import {
	XThemeForm,
	XThemeInputText,
	XThemeModal,
} from '../../../../styles/GlobalThemeStyle';
import VATimelineLoader from './VACaseTImeline/VATimelineLoader';
import VATimeline from './VACaseTImeline/VATimeline';
import config from '../../../../config';
import { diffWords } from 'diff';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { disableFutureDates, getUserToken } from '../../../../utils/helper';
import { filterByLabel } from '../../../../utils/formFunctions';
import { PlusOutlined } from '@ant-design/icons';
import {
	getAppealLetterApi,
	getAppealLetterReset,
} from '../../../../actions/getAppealLetterAction';
import { saveAppealLetterApi } from '../../../../actions/saveAppealLetterAction';
import { generateAppealLetterApi } from '../../../../actions/generateAppealLetterAction';
import { getConfigurationsApi } from '../../../../actions/getConfigurationsAction';
import {
	getRevisionApi,
	getRevisionReset,
} from '../../../../actions/getRevisionAction';

const VACaseAnalysisController = (props) => {
	const {
		action,
		actionParameters,
		analyseCoverage,
		analyseCoverageReset,
		analyseCoverageState,
		reviseCoverage,
		reviseCoverageReset,
		reviseCoverageState,
		editCase,
		editCaseState,
		editCaseReset,
		getAnalysisState,
		getAnalysis,
		getAnalysisReset,
		sendFeedback,
		sendFeedbackReset,
		sendFeedbackState,
		setProcessingAction,
		getAppealLetter,
		getAppealLetterState,
		getConfigurationsState,
		getConfigurations,
		getRevision,
		getRevisionReset,
		getRevisionState,
		getAppealLetterReset,
	} = props;
	const [form] = XForm.useForm();
	const [updateForm] = XForm.useForm();
	const [newOptionForm] = XForm.useForm();
	const [id, setId] = useState(null);
	const [formData, setFormData] = useState({
		status: 'success',
		successful_claim_commission_criteria: 'percentage',
		successful_claim_commission_fixed_value: null,
		successful_claim_commission_percentage_value: null,
		rejected_claim_commission_criteria: 'percentage',
		rejected_claim_commission_fixed_value: null,
		rejected_claim_commission_percentage_value: null,
		case_amount: null,
		claim_amount: null,
		status_logs: [],
	});
	const [patientData, setPatientData] = useState({});
	const [revenueCycleFormData, setRevenueCycleFormData] = useState({
		id: id,
		appeal_status: '',
		claim_category: '',
		claim_amount: null,
		status: '',
		revenue_cycle_stage: '',
		is_claim_amount_settled: null,
		claim_amount_updated_at: '',
		appeal_status_updated_at: '',
		reimbursed_at: '',
		revenue_cycle_updates: {
			revenue_cycle_status: '',
			appeal_status: '',
			remarks: '',
			url: [],
		},
		denial_reason: '',
		denial_code1: '',
		denial_code2: '',
	});
	const [pageContent, setPageContent] = useState({
		pastHistory: [],
		presentComplaint: [],
		recommendedProcedure: [],
		medicalCoverage: [],
	});
	const [flag, setFlag] = useState(true);
	const [matchGender, setMatchGender] = useState(true);
	const [feedbackId, setFeedbackId] = useState(null);
	const [loading, setLoading] = useState(false);
	const [appealLetterLoading, setAppealLetterLoading] = useState(false);
	const [downloadLoading, setDownloadLoading] = useState(false);
	const [modalTextArea, setModalTextArea] = useState('');
	const [modalOpen, setModalOpen] = useState([false, '', '', '', '']);
	const [thanksModal, setThanksModal] = useState([false, '']);
	const [fileList, setFileList] = useState([]);
	const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [previewTitle, setPreviewTitle] = useState('Upload Acknowledgement');
	const [selectedOption, setSelectedOption] = useState('textarea'); // Initial value can be 'textarea' or 'upload'
	const [revenueCycleStage, setRevenueCycleStage] = useState(''); // Initial value can be 'textarea' or 'upload'
	const [updateModalOpen, setUpdateModalOpen] = useState([false, '']);
	const [revenueCycleStatus, setRevenueCycleStatus] = useState('');
	const [timelineData, setTimelineData] = useState({});
	const [affixTop, setAffixTop] = React.useState(10);
	const [togglePrepareLetter, setTogglePrepareLetter] = useState(false);
	const [updatedFileList, setUpdatedFileList] = useState([]);
	const [submitCase, setSubmitCase] = useState(false); // Initial value can be 'textarea' or 'upload'
	const [documentsToDisplay, setDocumentsToDisplay] = useState([]);
	const [shouldDisplayCards, setShouldDisplayCards] = useState(false);
	const [matchDateOfBirth, setMatchDateOfbirth] = useState(true);
	// Missing fields related state
	const [missingFieldsModal, setMissingFieldsModal] = useState(false);
	const [missingFields, setMissingFields] = useState([]);
	const [missingFieldInstructions, setMissingFieldInstructions] = useState(
		[],
	);
	const [missingFieldTitle, setMissingFieldTitle] = useState('');
	const [missingFieldsForm] = XForm.useForm();
	const missingFieldsCardRef = useRef(null);
	const [lastAnalysisData, setLastAnalysisData] = useState({});
	const [showAnalysisData, setShowAnalysisData] = useState(false);
	const [analysisCompleted, setAnalysisCompleted] = useState('');
	const [isMissingFieldsThere, setIsMissingFieldsThere] = useState(false);
	const [denialReasonData, setDenialReasonData] = useState([]);
	const [newOptionText, setNewOptionText] = useState('');
	const [newCheckBoxModal, setNewCheckBoxModal] = useState([false, null]);
	const [updateCaseLoading, setUpdateCaseLoading] = useState(false);
	const [updateModalButtonText, setUpdateModalButtonText] =
		useState('Update');
	const [approveModalOpen, setApproveModalOpen] = useState(false);
	const [mainDataLoading, setMainDataLoading] = useState(true);
	//
	const [chatOpen, setChatOpen] = useState(false);
	const [messageList, setMessageList] = useState([]);
	//
	const [clinicalDocumentsToDisplay, setClinicalDocumentsToDisplay] =
		useState([]);
	const [clinicalForm] = XForm.useForm();
	const [clinicalDocsForm] = XForm.useForm();
	const [showClinicalTextArea, setShowClinicalTextArea] = useState(false);
	const [isClinicalUploadModalOpen, setIsClinicalUploadModalOpen] =
		useState(false);
	const [clinicalDocsLoading, setClinicalDocsLoading] = useState(false);
	const [clinicalDocumentFileList, setClinicalDocumentFileList] = useState(
		[],
	);
	const [
		updatedClinicalDocumentFileList,
		setUpdatedClinicalDocumentFileList,
	] = useState([]);
	const [submitClinicalDocs, setSubmitClinicalDocs] = useState(false); // Initial value can be 'textarea' or 'upload'
	const colors = ['#0C79FE', '#5DC466', '#FFA033', '#B67AD5'];
	const [coverageloading, setCoverageLoading] = useState(false);
	const [LooksGoodLoading, setLooksGoodLoading] = useState(false);
	const [clinicalSummaryTextLoading, setClinicalSummaryTextLoading] =
		useState(false);
	const [prevActiveCollapse, setPrevActiveCollapse] = useState(null);
	const [currentActiveCollapse, setCurrentActiveCollapse] = useState(null);
	// State for holding filters
	const [icdform] = XForm.useForm();
	const [cptform] = XForm.useForm();
	const [icdFilters, setIcdFilters] = useState({
		search: '',
		loaded_count: 0,
		limit: 10,
		related: false,
		childCode: '',
	});

	//CPT Codes
	const [cptFilters, setCptFilters] = useState({
		search: '',
		loaded_count: 0,
		limit: 10,
	});
	const [openIcdCptDrawer, setOpenIcdCptDrawer] = useState(false);
	const [openIcdCptDrawer2, setOpenIcdCptDrawer2] = useState(false);
	const [activeCode, setActiveCode] = useState(null);
	const [icdCodes, setIcdCodes] = useState([]); // To store fetched ICD codes
	const [searchResults, setSearchResults] = useState([]); // To store search results
	const [icdLoading, setIcdLoading] = useState(false); // To manage loading state
	const [triggeredBySearch, setTriggeredBySearch] = useState(false); // To track search-triggered calls
	const [triggeredByEnter, setTriggeredByEnter] = useState(false); // To track search-triggered calls
	const [loadMore, setLoadMore] = useState(false); // To track search-triggered calls
	const [icdSearchLoading, setIcdSearchLoading] = useState(false); // To manage loading state
	const [cptCodes, setCptCodes] = useState([]); // To store fetched ICD codes
	const [cptLoading, setCptLoading] = useState(false); // To manage loading state
	const [cptSearchResults, setCptSearchResults] = useState([]); // To store search results
	const [cptTriggeredBySearch, setCptTriggeredBySearch] = useState(false); // To track search-triggered calls
	const [cptTriggeredByEnter, setCptTriggeredByEnter] = useState(false); // To track search-triggered calls
	const [cptLoadMore, setCptLoadMore] = useState(false); // To track search-triggered calls
	const [cptSearchLoading, setCptSearchLoading] = useState(false); // To manage loading state
	const [denialLetterActionPerform, setDenialLetterActionPerform] =
		useState(false);
	const [supportingDocActionPerform, setSupportingDocActionPerform] =
		useState(false);
	const [sendLetterLoading, setSendLetterLoading] = useState(false);
	const [caseClosed, setCaseClosed] = useState(false);
	const [activeKey, setActiveKey] = useState('1');
	const [revisionList, setRevisionList] = useState([]);
	const [currentRevision, setCurrentRevision] = useState({});
	const [versionNumber, setVersionNumber] = useState('');
	const [typeAppeal, setTypeAppeal] = useState('');
	// Added state variables that might be referenced
	const [currentView, setCurrentView] = useState('skeleton');
	// Track whether analysis is in progress to prevent duplicate calls
	const [analysisInProgress, setAnalysisInProgress] = useState(false);
	// Track whether case details were opened from table
	const [openedFromTable, setOpenedFromTable] = useState(false);
	// Store previous action parameters to restore table state
	const [previousActionParameters, setPreviousActionParameters] = useState(null);

	// Parse case ID from action parameters
	useEffect(() => {
		if (actionParameters && actionParameters.case_id) {
			setId(actionParameters.case_id);
		}
	}, [actionParameters]);

	// Track if case details were opened from table
	useEffect(() => {
		console.log('=== VACaseAnalysisController openedFromTable Debug ===');
		console.log('action:', action);
		console.log('actionParameters:', actionParameters);
		
		const hasTableFilters = actionParameters && (
			actionParameters.for_page === 'case-filing' ||
			actionParameters.batch_id ||
			actionParameters.original_action
		);
		
		console.log('hasTableFilters:', hasTableFilters);
		console.log('actionParameters.for_page:', actionParameters?.for_page);
		console.log('actionParameters.batch_id:', actionParameters?.batch_id);
		console.log('actionParameters.original_action:', actionParameters?.original_action);
		
		const isFromTable = action === 'case-detail' && hasTableFilters;
		
		console.log('isFromTable:', isFromTable);
		console.log('Setting openedFromTable to:', isFromTable);
		
		setOpenedFromTable(isFromTable);
		
		if (isFromTable) {
			setPreviousActionParameters(actionParameters);
			console.log('Setting previousActionParameters to:', actionParameters);
		}
	}, [action, actionParameters]);

	// Initial API call to get analysis
	useEffect(() => {
		if (id) {
			setLoading(true);
			setMainDataLoading(true);
			setCurrentView('skeleton');
			getAnalysis({
				id: id,
				process_type: actionParameters?.process_type || 'rc',
			});
			getConfigurations({});
		}
	}, [id]);

	useEffect(() => {
		if (
			currentRevision?.field === 'past_history' ||
			currentRevision?.field === 'present_complaint' ||
			currentRevision?.field === 'suggested_treatment'
		) {
			const diff = findArrayDifferences(
				currentRevision?.oldValue,
				currentRevision?.newValue,
			);

			// Only update if `finalValue` is different to avoid unnecessary re-renders
			if (
				!currentRevision?.finalValue ||
				JSON.stringify(currentRevision.finalValue) !==
					JSON.stringify(diff)
			) {
				setCurrentRevision((prevRevision) => ({
					...prevRevision,
					finalValue: diff,
				}));
			}
		} else if (
			currentRevision?.field === 'clinical_summary' ||
			currentRevision?.field === 'summary_docs'
		) {
			// Function to generate highlighted text
			if (!currentRevision?.finalValue) {
				const diff = diffWords(
					currentRevision?.oldValue || '',
					currentRevision?.newValue || '',
				);
				const result = diff.map((part, index) => {
					// Determine if a space should be added
					const space = index < diff.length - 1 ? ' ' : '';

					if (part.added) {
						return (
							<span
								key={index}
								style={{
									backgroundColor: '#e1fcef',
									color: '#14804a',
								}}
							>
								{part.value}
							</span>
						);
					} else if (part.removed) {
						return (
							<span
								key={index}
								style={{
									backgroundColor: '#FFE9DA',
									color: '#cf1322',
								}}
							>
								{part.value}
								{/* {space} */}
							</span>
						);
					}
					return <span key={index}>{part.value}</span>;
				});

				setCurrentRevision((prevRevision) => ({
					...prevRevision,
					finalValue: result,
				}));
			}
		}
	}, [currentRevision]);

	function findArrayDifferences(oldArray, newArray) {
		const removedItems = oldArray.filter(
			(item) => !newArray.includes(item),
		);
		const addedItems = newArray.filter((item) => !oldArray.includes(item));

		return [
			...removedItems.map((item) => ({ value: item, type: 'removed' })),
			...addedItems.map((item) => ({ value: item, type: 'added' })),
			...newArray
				.filter((item) => oldArray.includes(item))
				.map((item) => ({ value: item, type: 'unchanged' })),
		];
	}

	useEffect(() => {
		if (modalOpen[0] && modalOpen[4] !== 'feedbackSummary') {
			// Check if modal is open and it's not the feedbackSummary modal
			const [description, code] = modalTextArea.split(' - ');
			form.setFieldsValue({
				modal_text_area: description || '', // Prepopulate description
				code: code ? code.split(': ')[1] : '', // Extract and prepopulate code
			});
		}
	}, [modalOpen, modalTextArea, form]);

	const handleTabsChange = (key) => {
		console.log('key in handleTabsChange', key, typeof key);
		setActiveKey(key);
		setCurrentRevision({});
		setVersionNumber('');
		if (key === '2') {
			getRevision({
				id: id,
			});
		}
	};

	useEffect(() => {
		let timer;
		if (thanksModal) {
			timer = setTimeout(() => {
				setThanksModal([false, '']);
			}, 5000);
		}

		// Clear the timer if the component unmounts or showThanksModal changes
		return () => clearTimeout(timer);
	}, [thanksModal]);

	// Coding tools Add this useEffect to handle tab switching
	const [activeTab, setActiveTab] = useState('1');
	// Add new state variables to track drawer states separately
	const [openIcdDrawer, setOpenIcdDrawer] = useState(true);
	const [openCptDrawer, setOpenCptDrawer] = useState(true);

	useEffect(() => {
		if (openIcdCptDrawer2 && activeCode?.type === 'CPT') {
			setActiveTab('2');
		} else {
			setActiveTab('1');
		}
	}, [openIcdCptDrawer2]);

	// Example of handleCodeClick
	const handleCodeClick = (codeType, codeData, flag) => {
		// Check if the code has leading or trailing spaces
		let trimmedCode = codeData.code;

		if (trimmedCode !== trimmedCode.trim()) {
			trimmedCode = trimmedCode.trim();
		}

		// // Check if it's a child code
		// const isChildCode = trimmedCode.includes('.');
		// const parentCode = isChildCode
		// 	? trimmedCode.split('.')[0]
		// 	: trimmedCode;
		setIcdCodes();
		closeIcdCptDrawer(flag);
		setActiveCode({
			type: codeType,
			code: codeData.code,
			description: codeData.description,
			codeTypeText: codeData.codeTypeText,
			buttontext: codeData.buttontext,
		});

		if (codeType === 'CPT') {
			// // Set filters to fetch related codes
			setCptFilters({
				related: true,
				childCode: trimmedCode,
			});
			setCptTriggeredByEnter(true);
			setOpenIcdCptDrawer2(true); // Open the related codes drawer
			// setOpenIcdCptDrawer(false);
			setOpenCptDrawer(false);
			setOpenIcdDrawer(true);
			setActiveTab('2');
		} else {
			// Set filters to fetch related codes
			setIcdFilters({
				related: true,
				childCode: trimmedCode,
			});
			setTriggeredByEnter(true);
			setOpenIcdCptDrawer2(true); // Open the related codes drawer
			// setOpenIcdCptDrawer(false);
			setOpenIcdDrawer(false);
			setOpenCptDrawer(true);
			setActiveTab('1');
		}
	};

	const showIcdCptDrawer = () => {
		setOpenIcdCptDrawer(true);
		setIcdCodes();
		setActiveCode(null);
		setSearchResults();
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptCodes();
		setCptSearchResults();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const closeIcdCptDrawer = (flag) => {
		if (flag === 'true') {
		} else {
			setOpenIcdCptDrawer(false);
		}
		setOpenIcdDrawer(true);
		setOpenCptDrawer(true);
		setActiveCode(null);
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const closeIcdCptDrawer2 = () => {
		setOpenIcdDrawer(true);
		setOpenCptDrawer(true);
		setOpenIcdCptDrawer2(false);
		setActiveCode(null);
		setIcdLoading(false);
		setTriggeredBySearch(false);
		setIcdSearchLoading(false);
		setLoadMore(false);
		icdform.resetFields();
		setCptLoading(false);
		setCptTriggeredBySearch(false);
		setCptSearchLoading(false);
		setCptLoadMore(false);
		cptform.resetFields();
	};

	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	useEffect(() => {
		if (getAppealLetterState.apiState === 'success') {
			setAppealLetterLoading(false);
			Navigate(`/case/filings/preview/${id}`, {
				state: {
					appealLetterType: typeAppeal,
					patientDetails: patientData,
					content: getAppealLetterState.data.appeal_letter,
					header: getAppealLetterState.data.header,
					footer: getAppealLetterState.data.footer,
					isEdit: false,
				},
			});
		} else if (getAppealLetterState.apiState === 'error') {
			setAppealLetterLoading(false);
			notification.error({
				message: getAppealLetterState.message
					? getAppealLetterState.message
					: 'Unable to get Appeal Letter content',
			});
		}
		getAppealLetterReset();
	}, [getAppealLetterState.apiState]);

	const viewAppealLetter = (regenerate = false) => {
		setAppealLetterLoading(true);
		getAppealLetter({
			id: id,
			type: typeAppeal,
			regenerate_appeal_letter: regenerate,
		});
	};

	const handlePreviewBeforUpload = async (file) => {
		if (file && file.name && file.name.split('.').includes('pdf')) {
			setPreviewImage(file.url || file.preview);
			setPdfPreviewOpen(true);
		} else {
			if (!file.url && !file.preview) {
				file.preview = await getBase64(file.originFileObj);
			}
			setPreviewImage(file.url || file.preview);
			setPreviewTitle(
				file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
			);
		}
	};

	const handleDownload = (file) => {
		// Assuming 'file' contains the URL of the file to download
		window.open(file.url, '_blank');
	};

	const uploadButton = (
		<Button
			id="revnueModalUploadButton"
			style={{
				border: 0,
				boxShadow: 'none',
				background: 'none',
				color: 'black',
				margin: '0',
			}}
		>
			<PlusOutlined />
			<div>Upload</div>
		</Button>
	);

	const updatePageContent = (title, id, content) => {
		if (id === null) {
			setPageContent({
				...pageContent,
				[title]: [...pageContent[[title]], content],
			});
		} else {
			const updatedPageContent = { ...pageContent };
			updatedPageContent[[title]][id] = content;
			setPageContent(updatedPageContent);
		}
		setModalOpen([false, '', ' ']);
		setModalTextArea('');
		form.resetFields();
		document.getElementById('notification')?.classList.remove('d-none');
	};

	const dateOfBirth = (inputDateString) => {
		const date = new Date(inputDateString);

		// Extract the year, month, and day components from the Date object
		const year = date.getFullYear();
		const month = date.getMonth() + 1; // Month is zero-based, so add 1
		const day = date.getDate();

		// Format the date as "MM-DD-YYYY" or any desired format
		return `${month.toString().padStart(2, '0')}-${day
			.toString()
			.padStart(2, '0')}-${year}`;
	};

	function compareDates(dateString, yearNumber) {
		// Parse the date string using Moment.js
		const dateOfBirth = moment(dateString);

		// Calculate the current year
		const currentYear = moment().year();

		// Extract the year from the parsed date of birth
		const birthYear = dateOfBirth.year();

		// Calculate the age by subtracting the birth year from the current year
		const age = currentYear - birthYear;
		// Extract the last two digits of the year number
		const yearDigits = parseInt(yearNumber.toString().slice(-2));
		// Compare the years
		return age === yearDigits;
	}

	function compareGender(patientGender, analysisGender) {
		// Get the first character of the analysisGender string and normalize to uppercase
		const firstCharAnalysis = analysisGender.charAt(0).toUpperCase();

		// Check if patientGender is "M" (Male) or "F" (Female)
		if (
			patientGender?.toUpperCase() === 'MALE' ||
			patientGender?.toUpperCase() === 'FEMALE'
		) {
			// Compare the first character of analysisGender with patientGender
			return firstCharAnalysis === patientGender?.charAt(0).toUpperCase();
		} else {
			// Match patientGender with "O" (Other)
			return firstCharAnalysis === 'O';
		}
	}

	useEffect(() => {
		if (editCaseState.apiState === 'loading') {
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'thinking',
					response: 'Updating case status...',
					action: 'analyze_case',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
				});
			}
		}
		if (editCaseState.apiState === 'success') {
			if (sendLetterLoading) {
				setSendLetterLoading(false);
				// navigate(-1);
			}
			setSendLetterLoading(false);
			setCurrentActiveCollapse(null);
			setPrevActiveCollapse(null);
			setClinicalSummaryTextLoading(false);
			handleUploadCancel();
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			setUpdateModalButtonText('Update');
			setUpdateCaseLoading(false);
			// getAnalysis({ id: id });
			// if (flag)
			// 	notification.success({
			// 		message: 'Case updated successfully',
			// 	});
			setModalOpen([false, '']);
			editCaseReset();
			setUpdateModalOpen([false, '']);
			updateForm.setFieldsValue({});
			setRevenueCycleFormData({
				id: id,
				appeal_status: '',
				reimbursed_at: '',
				claim_category: '',
				claim_amount: null,
				status: '',
				denial_reason: '',
				denial_code1: '',
				denial_code2: '',
				revenue_cycle_stage: '',
				is_claim_amount_settled: null,
				claim_amount_updated_at: '',
				appeal_status_updated_at: '',
				revenue_cycle_updates: {
					revenue_cycle_status: '',
					appeal_status: '',
					remarks: '',
					url: [],
				},
			});
			setRevenueCycleStage('');
			updateForm.resetFields();
			setSubmitCase(false);
			setSelectedOption('');
			setFileList([]);
			// getRevision({
			// 	id: id,
			// });
			if (
				flag &&
				!denialLetterActionPerform &&
				!supportingDocActionPerform
			) {
				getAnalysis({ id: id });
			}
			getAnalysis({ id: id });
			setFlag(true);
			editCaseReset();
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Case updated successfully',
					action: 'case-detail',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
					store_message: true,
				});
			}
		}
		setFlag(true);
		if (editCaseState.apiState === 'error') {
			setClinicalSummaryTextLoading(false);
			handleUploadCancel();
			setClinicalDocsLoading(false);
			setShowClinicalTextArea(false);
			setSubmitCase(false);
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Error updating case status, please try again.',
					action: 'case-detail',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
					store_message: true,
				});
			}
			notification.error({
				message: editCaseState.message
					? editCaseState.message
					: 'Unable to update case status, Please try again',
			});
		}
		editCaseReset();
	}, [editCaseState]);

	// Handle getAnalysis response
	useEffect(() => {
		if (getAnalysisState.apiState === 'error') {
			setMainDataLoading(false);
			setLoading(false);
			setCurrentView('error');
			if (setProcessingAction) {
				setProcessingAction(false);
			}
			notification.error({
				message: 'Error',
				description:
					getAnalysisState.message || 'Failed to get case analysis',
			});
		}

		if (getAnalysisState.apiState === 'success') {
			setMainDataLoading(false);
			setShowClinicalTextArea(false);

			if (
				getAnalysisState.data.case_details &&
				getAnalysisState.data.case_details.allocated_to === null
			) {
				if (props.onUserInputRequired) {
					props.onUserInputRequired({
						response_type: 'text',
						response:
							"Oops! It seems like this case hasn't been allocated to anyone yet. Please allocate it first before proceeding with the analysis.",
						action: 'analyze_case',
						component: 'case_analysis',
						parameters: {
							case_id: id,
							process_type: 'rc',
						},
						store_message: true,
					});
				}
				notification.error({
					message: 'Case Not Allocated',
					description:
						"Oops! It seems like this case hasn't been allocated to anyone yet. Please allocate it first before proceeding with the analysis.",
				});
				if (setProcessingAction) {
					setProcessingAction(false);
				}
				getAnalysisReset();
			}

			setPatientData(getAnalysisState.data.case_details);

			// Set page content based on analysis data
			setPageContent({
				...pageContent,
				originalQuery:
					getAnalysisState.data.coverage_feedback_response[
						'original_query'
					] ?? '-',
				pastHistory:
					getAnalysisState.data.coverage_feedback_response[
						'Past History'
					] ?? [],
				presentComplaint:
					getAnalysisState.data.coverage_feedback_response[
						'Present Complaint'
					] ?? [],
				recommendedProcedure:
					getAnalysisState.data.coverage_feedback_response[
						'Suggested Treatment'
					] ?? [],
				medicalCoverage: [
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Coverage']
						: 'No',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['Rationale']
						: '-',
					getAnalysisState.data.coverage_feedback_response[
						'Medicare Evaluation'
					]
						? getAnalysisState.data.coverage_feedback_response[
								'Medicare Evaluation'
						  ]['reference']
						: null,
				],
				missing_points_for_coverage:
					getAnalysisState.data.coverage_feedback_response
						.missing_points_for_coverage ?? [],
				status: getAnalysisState.data.coverage_feedback_response.status,
				ncd_reference:
					getAnalysisState.data.coverage_feedback_response[
						'NCD References'
					] ?? '',
				retired_message:
					getAnalysisState.data.coverage_feedback_response
						.retired_message ?? '',
				is_retired:
					getAnalysisState.data.coverage_feedback_response
						.is_retired ?? 0,
			});

			// Check demographic matches
			if (
				getAnalysisState.data.coverage_feedback_response &&
				getAnalysisState.data.coverage_feedback_response?.age
			) {
				setMatchDateOfbirth(
					compareDates(
						getAnalysisState.data.case_details.date_of_birth,
						getAnalysisState.data.coverage_feedback_response.age,
					),
				);
			}

			if (
				getAnalysisState.data.coverage_feedback_response &&
				getAnalysisState.data.coverage_feedback_response?.gender
			) {
				setMatchGender(
					compareGender(
						getAnalysisState.data.case_details.gender,
						getAnalysisState.data.coverage_feedback_response.gender,
					),
				);
			}

			// Set analysis data
			setLastAnalysisData(
				getAnalysisState.data.coverage_feedback_response,
			);
			setFeedbackId(getAnalysisState.data.coverage_feedback_response._id);
			document.getElementById('getAns')?.classList.add('top-0');
			document.getElementById('getAns')?.classList.remove('top-100');
			setTimelineData(getAnalysisState.data?.timelineData);
			// Check if the last timeline entry indicates that the case is closed
			const lastTimelineEntry =
				getAnalysisState.data.timelineData?.slice(-1)[0];
			if (
				lastTimelineEntry &&
				(lastTimelineEntry.appeal_status === 'Approved' ||
					lastTimelineEntry.appeal_status === 'Rejected')
			) {
				setCaseClosed(true);
			} else {
				setCaseClosed(false);
			}
			const revenueCycleDocs =
				getAnalysisState.data.case_details
					.revenue_cycle_supporting_documents;

			if (revenueCycleDocs && revenueCycleDocs.length > 0) {
				// Modify fileList to add the prefix to URLs
				const modifiedFileList = revenueCycleDocs.map((file) => ({
					...file,
					url: `${config.s3_url}${file.url}`,
				}));
				setFileList([...modifiedFileList]);
				setSelectedOption('upload');
				setSelectedOption('upload');
			}

			const supportingDocs =
				getAnalysisState.data.case_details.supporting_docs.length > 0 &&
				getAnalysisState.data.case_details.supporting_docs.map(
					(doc) => {
						return doc;
					},
				);
			setDocumentsToDisplay(supportingDocs);

			const clinicalDocs =
				getAnalysisState.data.case_details.clinical_docs.map((doc) => {
					return doc;
				});
			setClinicalDocumentsToDisplay(clinicalDocs);

			const isAnyArrayNotEmpty = Object.keys(pageContent)
				.filter((key) => key !== 'medicalCoverage')
				.some((key) => pageContent[key].length > 0);

			setShouldDisplayCards(isAnyArrayNotEmpty);
		}
	}, [getAnalysisState.apiState]);

	useEffect(() => {
		if (getAnalysisState.apiState === 'success') {
			setShowClinicalTextArea(false);
			const { coverage_feedback_response } = getAnalysisState.data;
			// Check if Medicare Evaluation is empty
			// Check if coverage_feedback_response is empty or if "Medicare Evaluation" is missing or empty
			const isMedicareEvaluationEmpty =
				!coverage_feedback_response?.['Medicare Evaluation'] ||
				Object.keys(coverage_feedback_response['Medicare Evaluation'])
					.length === 0;

			// Check if analysis is needed
			if (
				!coverage_feedback_response ||
				Object.keys(coverage_feedback_response || {}).length === 0 ||
				isMedicareEvaluationEmpty
			) {
				// Only trigger analysis if not already in progress
				if (!analysisInProgress) {
					if (patientData.allocated_to) {
						// We need to trigger a new analysis
						setCurrentView('loader');
						setLoading(true);
						setAnalysisInProgress(true);
						document
							.getElementById('notification')
							?.classList.add('d-none');
						analyseCoverage({
							clinicalSummary: patientData.clinical_summary,
							case_id: patientData._id,
							state: patientData.state,
							provider: patientData.insurance_company?.name,
							supportingDocsSummary: patientData.summary_docs,
							revenue_cycle: patientData.revenue_cycle,
						});
					}
				}
			} else {
				// No analysis needed, set appropriate view
				setLoading(false);
				setAnalysisInProgress(false);
				setCurrentView(
					action === 'case_timeline'
						? 'case_timeline'
						: 'case-details',
				);
				setShowAnalysisData(true);
				//Todo uncomment if confrm user input doest ask
				// if (pageContent.status && pageContent.status !== 'approved') {
				// 	console.log(
				// 		'Creating user input request for coverage confirmation',
				// 	);

				// 	// Case is loaded and analyzed but not approved - ask user if they want to confirm coverage
				// 	const userInputRequest = {
				// 		response_type: 'user_input_required',
				// 		response: 'Do you want to confirm this case coverage?',
				// 		action: 'confirm_coverage',
				// 		component: 'case_analysis',
				// 		parameters: {
				// 			case_id: id,
				// 			feedback_id: feedbackId,
				// 			process_type: 'rc',
				// 		},
				// 		user_input: {
				// 			title: 'Would you like to confirm the coverage for this case?',
				// 			input_type: 'buttons',
				// 			parameter_key: 'confirm_coverage',
				// 			options: [
				// 				{
				// 					label: 'Yes, confirm coverage',
				// 					value: 'Yes',
				// 				},
				// 				{ label: 'Not now', value: 'No' },
				// 			],
				// 		},
				// 	};

				// 	// Add some logging to troubleshoot
				// 	console.log(
				// 		'Sending user input request:',
				// 		userInputRequest,
				// 	);

				// 	// Pass this to the parent component through a callback
				// 	if (props.onUserInputRequired) {
				// 		props.onUserInputRequired(userInputRequest);
				// 	}
				// }
			}
		}
		getAnalysisReset();
	}, [patientData]);

	useEffect(() => {
		if (showAnalysisData) {
			document.getElementById('getAns')?.classList.add('top-0');
			document.getElementById('getAns')?.classList.remove('top-100');
		}
	}, [showAnalysisData]);

	// Handle analyseCoverage response
	useEffect(() => {
		if (analyseCoverageState.apiState === 'loading') {
			setLoading(true);
			setCurrentView('loader');
			// Add thinking message for analysis
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'thinking',
					response: 'Analyzing the case...',
					action: 'analyze_case',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
				});
			}
		} else if (
			analyseCoverageState.apiState === 'success' &&
			id === analyseCoverageState.data?.case_id
		) {
			// Update patientData if original was empty
			if (
				(!patientData.clinical_summary || !patientData.summary_docs) &&
				(analyseCoverageState.data.original_query ||
					analyseCoverageState.data.supportingDocsSummary)
			) {
				setPatientData((prevData) => ({
					...prevData,
					clinical_summary:
						analyseCoverageState.data.original_query ||
						prevData.clinical_summary,
					summary_docs:
						analyseCoverageState.data.supportingDocsSummary ||
						prevData.summary_docs,
				}));
			}

			setFeedbackId(analyseCoverageState.data.feedback_id);
			setLastAnalysisData(analyseCoverageState.data);

			// Update pageContent with analysis results
			setPageContent({
				...pageContent,
				originalQuery:
					analyseCoverageState.data['original_query'] ?? '',
				pastHistory: analyseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					analyseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					analyseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					analyseCoverageState.data['Medicare Evaluation']
						? analyseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					analyseCoverageState.data.missing_points_for_coverage ?? [],
				ncd_reference:
					analyseCoverageState.data['NCD References'] ?? '',
				retired_message:
					analyseCoverageState.data.retired_message ?? '',
				is_retired: analyseCoverageState.data.is_retired ?? 0,
			});
			// setAnalysisCompleted('success');
			if (
				analyseCoverageState.data &&
				analyseCoverageState.data.date_of_birth
			)
				setMatchDateOfbirth(
					compareDates(
						patientData.date_of_birth,
						analyseCoverageState.data.age,
					),
				);

			if (analyseCoverageState.data && analyseCoverageState.data.gender)
				setMatchGender(
					compareGender(
						patientData.gender,
						analyseCoverageState.data.gender,
					),
				);

			// Check for missing fields
			if (
				analyseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				analyseCoverageState.data.is_fields_missing &&
				analyseCoverageState.data.hasOwnProperty('missing_fields') &&
				analyseCoverageState.data.missing_fields.length > 0
			) {
				setMissingFields(
					analyseCoverageState.data.missing_fields ?? [],
				);
				setMissingFieldInstructions(
					analyseCoverageState.data.missing_field_instructions ?? [],
				);
				setMissingFieldTitle(
					analyseCoverageState.data.missing_field_title ?? '',
				);

				// Store missing fields message in backend
				if (props.onUserInputRequired) {
					props.onUserInputRequired({
						response_type: 'text',
						response:
							'Missing fields detected. Please select the appropriate CPT codes to proceed with the analysis.',
						action: 'analyze_case',
						component: 'case_analysis',
						parameters: {
							case_id: id,
							feedback_id: analyseCoverageState.data.feedback_id,
							process_type: 'rc',
						},
						store_message: true, // Flag to indicate this should be stored
					});
				}

				// For missing fields, we don't complete the loading steps
				setMissingFieldsModal(true);
				setIsMissingFieldsThere(true);
				setCurrentView('missing-fields');
				setLoading(false);
				setAnalysisInProgress(false);
			} else {
				// For successful analysis without missing fields,
				// set completion but keep loader visible to show steps
				setIsMissingFieldsThere(false);
				setShowAnalysisData(true);
				setAnalysisCompleted('success');
				if (props.onUserInputRequired) {
					props.onUserInputRequired({
						response_type: 'text',
						response:
							'Request completed. Here are the case details.',
						action: 'case-detail',
						component: 'case_analysis',
						parameters: {
							case_id: id,
							process_type: 'rc',
						},
						store_message: true,
					});
				}
				// The loader component will handle transitioning to case-details
				// after showing all the steps
			}

			if (setProcessingAction) {
				setProcessingAction(false);
			}
		} else if (analyseCoverageState.apiState === 'error') {
			setShowClinicalTextArea(false);
			setAnalysisCompleted('error');
			setIsMissingFieldsThere(false);
			setLoading(false);
			setCurrentView('error');
			setAnalysisInProgress(false);
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response:
						'Hey, we are facing high traffic. Please check back in few minutes.',
					action: 'analyze_case',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
					store_message: true,
				});
			}
			notification.error({
				message:
					'Hey, we are facing high traffic. Please check back in few minutes.',
			});

			if (setProcessingAction) {
				setProcessingAction(false);
			}

			analyseCoverageReset();
		}
	}, [analyseCoverageState]);

	// Handle reviseCoverage response
	useEffect(() => {
		if (reviseCoverageState.apiState === 'loading') {
			setLoading(true);
			setCurrentView('loader');
			// Show thinking message for reanalysis
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'thinking',
					response: 'Reanalyzing the case...',
					action: 'analyze_case',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
				});
			}
		} else if (
			reviseCoverageState.apiState === 'success' &&
			id === reviseCoverageState.data?.case_id
		) {
			setShowClinicalTextArea(false);
			setFeedbackId(reviseCoverageState.data.feedback_id);
			setLastAnalysisData(reviseCoverageState.data);

			// Don't reset analysisInProgress yet - we need to let loader complete its steps

			// Update pageContent with revised data
			setPageContent({
				...pageContent,
				originalQuery: reviseCoverageState.data['original_query'] ?? '',
				pastHistory: reviseCoverageState.data['Past History'] ?? [],
				presentComplaint:
					reviseCoverageState.data['Present Complaint'] ?? [],
				recommendedProcedure:
					reviseCoverageState.data['Suggested Treatment'] ?? [],
				medicalCoverage: [
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Coverage'
						  ]
						: 'No',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'Rationale'
						  ]
						: '',
					reviseCoverageState.data['Medicare Evaluation']
						? reviseCoverageState.data['Medicare Evaluation'][
								'reference'
						  ]
						: null,
				],
				missing_points_for_coverage:
					reviseCoverageState.data.missing_points_for_coverage ?? [],
				status: reviseCoverageState.data.status,
				ncd_reference: reviseCoverageState.data['NCD References'] ?? '',
				retired_message: reviseCoverageState.data.retired_message ?? '',
				is_retired: reviseCoverageState.data.is_retired ?? 0,
			});
			setAnalysisCompleted('success');

			// Check demographic matches
			if (reviseCoverageState.data && reviseCoverageState.data.age) {
				setMatchDateOfbirth(
					compareDates(
						patientData.date_of_birth,
						reviseCoverageState.data.age,
					),
				);
			}

			if (reviseCoverageState.data && reviseCoverageState.data.gender) {
				setMatchGender(
					compareGender(
						patientData.gender,
						reviseCoverageState.data.gender,
					),
				);
			}

			// Check for missing fields
			if (
				reviseCoverageState.data.hasOwnProperty('is_fields_missing') &&
				reviseCoverageState.data.is_fields_missing &&
				reviseCoverageState.data.hasOwnProperty('missing_fields') &&
				reviseCoverageState.data.missing_fields.length > 0
			) {
				// Set missing fields data
				setMissingFields(reviseCoverageState.data.missing_fields ?? []);
				setMissingFieldInstructions(
					reviseCoverageState.data.missing_field_instructions ?? [],
				);
				setMissingFieldTitle(
					reviseCoverageState.data.missing_field_title ?? '',
				);

				// Add system message about missing fields
				if (props.onUserInputRequired) {
					props.onUserInputRequired({
						response_type: 'text',
						response:
							'Missing fields detected. Please select the appropriate CPT codes to proceed with the analysis.',
						action: 'analyze_case',
						component: 'case_analysis',
						parameters: {
							case_id: id,
							feedback_id: reviseCoverageState.data.feedback_id,
							process_type: 'rc',
						},
						store_message: true,
					});
				}

				// For missing fields, we don't complete the loading steps
				setIsMissingFieldsThere(true);
				setMissingFieldsModal(true);
				setCurrentView('missing-fields');
				setLoading(false);
				setAnalysisInProgress(false);
			} else {
				// For successful analysis without missing fields,
				// set completion but keep loader visible to show steps
				setShowAnalysisData(true);
				// setAnalysisCompleted('success');
				setIsMissingFieldsThere(false);
				// The loader component will handle transitioning to case-details
				// after showing all the steps
				// Store completion message
				if (props.onUserInputRequired) {
					props.onUserInputRequired({
						response_type: 'text',
						response:
							'Request completed. Here are the case details.',
						action: 'case-detail',
						component: 'case_analysis',
						parameters: {
							case_id: id,
							feedback_id: reviseCoverageState.data.feedback_id,
							process_type: 'rc',
						},
						store_message: true,
					});
				}
			}
			if (setProcessingAction) {
				setProcessingAction(false);
			}
			reviseCoverageReset();

			// After successful reanalysis, check if we need to show the confirmation message
			if (pageContent.status && pageContent.status !== 'approved') {
				// // Add a small delay to ensure the previous message is processed
				// setTimeout(() => {
				if (props.onUserInputRequired) {
					props.onUserInputRequired({
						response_type: 'user_input_required',
						response: 'Do you want to confirm this case coverage?',
						action: 'confirm_coverage',
						component: 'case_analysis',
						parameters: {
							case_id: id,
							feedback_id: feedbackId,
							process_type: 'rc',
						},
						user_input: {
							title: 'Would you like to confirm the coverage for this case?',
							input_type: 'buttons',
							parameter_key: 'confirm_coverage',
							options: [
								{
									label: 'Yes, confirm coverage',
									value: 'Yes',
								},
								{ label: 'Not now', value: 'No' },
							],
						},
					});
				}
				// }, 500); // Add a small delay to ensure proper message sequencing
			}
		} else if (reviseCoverageState.apiState === 'error') {
			setShowClinicalTextArea(false);
			setLoading(false);
			setAnalysisCompleted('error');
			setCurrentView('error');
			setAnalysisInProgress(false);
			// Show thinking message for reanalysis error
			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response:
						'Hey, we are facing high traffic. Please check back in few minutes.',
					action: 'analyze_case',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
					store_message: true,
				});
			}
			// notification.error({
			// 	message:
			// 		'Hey, we are facing high traffic. Please check back in few minutes.',
			// });

			document.getElementById('notification')?.classList.remove('d-none');

			if (setProcessingAction) {
				setProcessingAction(false);
			}
			reviseCoverageReset();
		}
	}, [reviseCoverageState.apiState]);

	// Handle sendFeedback response
	useEffect(() => {
		if (sendFeedbackState.apiState === 'success') {
			setCoverageLoading(false);
			setLooksGoodLoading(false);
			setModalOpen([false, '', '']);

			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response:
						sendFeedbackState.data === 'negative'
							? 'Thanks for making us Better!'
							: 'Case has been analysed and confirmed!',
					action: 'case-detail',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
					store_message: true,
				});
			}

			notification.success({
				message:
					sendFeedbackState.data === 'negative'
						? 'Thanks for making us Better!'
						: 'Case has been analysed and confirmed!',
			});

			// Refresh analysis after feedback
			if (id) {
				getAnalysis({
					id: id,
					process_type: actionParameters?.process_type || 'rc',
				});
			}

			sendFeedbackReset();
		}
		if (sendFeedbackState.apiState === 'error') {
			setCoverageLoading(false);
			setLooksGoodLoading(false);

			if (props.onUserInputRequired) {
				props.onUserInputRequired({
					response_type: 'text',
					response: 'Error submitting feedback',
					action: 'case-detail',
					component: 'case_analysis',
					parameters: {
						case_id: id,
						process_type: 'rc',
					},
				});
			}

			notification.error({
				message: 'Error submitting feedback',
				description:
					sendFeedbackState.message ||
					'An error occurred while submitting feedback',
			});
			sendFeedbackReset();
		}
	}, [sendFeedbackState]);

	useEffect(() => {
		if (getConfigurationsState.apiState === 'success') {
			if (getConfigurationsState.data.all_configurations.length > 0) {
				getConfigurationsState.data.all_configurations.map((option) => {
					if (option.key === 'denial_reason') {
						const optionsList = option.options.map((opt) => ({
							value: opt.value,
							label: opt.label,
						}));
						setDenialReasonData(optionsList);
					}
				});
			}
		}
	}, [getConfigurationsState]);

	const resetFormFields = () => {
		setRevenueCycleFormData({
			...revenueCycleFormData,
			reimbursed_at: '',
			claim_category: '',
			claim_amount: null,
			is_claim_amount_settled: null,
			claim_amount_updated_at: '',
			appeal_status_updated_at: '',
			revenue_cycle_updates: {
				revenue_cycle_status: '',
				appeal_status: '',
				remarks: '',
				url: [],
			},
			denial_reason: '',
			denial_code1: '',
			denial_code2: '',
		});
		setFileList([]);
		updateForm.resetFields([
			'claim_category',
			'claim_amount',
			'is_claim_amount_settled',
			'claim_amount_updated_at',
			'appeal_status_updated_at',
			'remarks',
			'revenue_cycle_supporting_documents',
			'denial_reason',
			'denial_code1',
			'denial_code2',
			'rejected_category',
		]);
		setSelectedOption('');
	};

	// Function to handle changes in the form fields
	const handleInputChange = (e) => {
		const { name, value } = e.target;

		// Update the state based on the field name
		if (name === 'appeal_status') {
			resetFormFields();
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				appeal_status: value,
				revenue_cycle_stage: revenueCycleStage,
				revenue_cycle_updates: {
					appeal_status: value,
					revenue_cycle_status: revenueCycleStage,
				},
				status: value === 'approved' ? 'successful' : 'rejected',
			}));
		} else if (name === 'claim_category') {
			// Update claim_category and claim_amount based on the selected value
			const claimAmount = value === 'full' ? patientData.case_amount : '';
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				claim_category: value,
				claim_amount: claimAmount,
			}));
			// If claim_category is 'full', disable the claim_amount field
			if (value === 'full') {
				updateForm.setFieldsValue({ claim_amount: claimAmount });
			} else {
				updateForm.setFieldsValue({ claim_amount: '' });
			}
		} else if (name === 'claim_amount') {
			// Update claim_amount
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				claim_amount: value,
			}));
		} else if (name === 'remarks') {
			setFileList([]);
			updateForm.resetFields(['revenue_cycle_supporting_documents']);
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				revenue_cycle_stage: revenueCycleStage,
				revenue_cycle_updates: {
					...prevState.revenue_cycle_updates,
					remarks: value,
				},
			}));
		} else if (name === 'is_claim_amount_settled') {
			// if (value === false) {
			// 	updateForm.setFieldsValue({
			// 		claim_amount: '',
			// 		claim_category: '',
			// 		claim_amount_updated_at: '',
			// 	});
			// 	setRevenueCycleFormData((prevState) => ({
			// 		...prevState,
			// 		claim_amount: '',
			// 		claim_category: '',
			// 		claim_amount_updated_at: '',
			// 	}));
			// }
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				is_claim_amount_settled: value,
			}));
		} else if (name === 'denial_code1') {
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				denial_code1: value,
			}));
		} else if (name === 'denial_code2') {
			setRevenueCycleFormData((prevState) => ({
				...prevState,
				denial_code2: value,
			}));
		}
	};

	// Handle changes in the Select component
	const handleSelect = (value, fieldName) => {
		setRevenueCycleFormData((prevState) => ({
			...prevState,
			[fieldName]: value,
		}));
	};

	const handleDateChange = (date, name) => {
		const formattedDate = date
			? date.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
			: null;
		setRevenueCycleFormData((prevState) => ({
			...prevState,
			[name]: formattedDate,
			...(name === 'appeal_status_updated_at' &&
				prevState.appeal_status === 'approved' && {
					claim_amount_updated_at: formattedDate,
				}),
		}));
	};

	const handleChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setFileList(updatedFileList);
		updateForm.validateFields(['revenue_cycle_supporting_documents']);
	};

	const handleSubmit = async () => {
		try {
			// if (revenueCycleFormData.status === 'rejected' && selectedOption === 'revenue_cycle_supporting_documents' && fileList.length === 0) {
			// 	notification.error({
			// 		message: 'Submission Error',
			// 		description: 'Please upload supporting documents before submitting.',
			// 	});
			// 	return;
			// }
			if (fileList.length > 0) {
				setUpdateCaseLoading(true);
				setUpdateModalButtonText('Processing Denial Letter');
				await Promise.all(
					fileList.map(async (fileData) => {
						let get_ext = fileData.originFileObj.name.split('.');
						let ext = get_ext[get_ext.length - 1];
						const res = await axios.get(
							`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=case_supporting_documents&file_name=${patientData.patient_last_name}&ext=${ext}&id=${patientData.case_id}`,
							{
								headers: {
									'Content-type':
										'application/json; charset=UTF-8',
									Authorization: 'Bearer ' + getUserToken(),
								},
							},
						);

						const result = await axios.put(
							res.data.data,
							fileData.originFileObj,
						);
						if (result.status === 200) {
							// const documentPath = `/case_supporting_documents/${patientData.mrn}${fileData.originFileObj.uid}/${patientData.patient_last_name}.${ext}`;
							const documentPath = `/case_supporting_documents/${patientData.case_id}/${patientData.patient_last_name}.${ext}`;
							const newFile = {
								uid: fileData.originFileObj.uid,
								name: fileData.originFileObj.name,
								status: 'done',
								url: documentPath,
							};
							setUpdatedFileList((prevFileList) => [newFile]);
						}
					}),
				).then((res) => {
					setUpdateModalButtonText('Processing Denial Letter');
					setSubmitCase(true);
				});
			} else {
				setUpdateModalButtonText('Updating');
				editCase(revenueCycleFormData);
			}
		} catch (error) {
			setUpdateModalButtonText('Update');
			setUpdateCaseLoading(false);
			setSubmitCase(false);
			// Handle error if any
			console.error('Error occurred:', error);
		}
	};

	useEffect(() => {
		if (submitCase) {
			editCase({
				...revenueCycleFormData,
				revenue_cycle_updates: {
					...revenueCycleFormData.revenue_cycle_updates,
					url: updatedFileList,
					revenue_cycle_status:
						revenueCycleFormData.revenue_cycle_stage,
					remarks: null,
				},
			});
		}
	}, [submitCase]);

	const handleAddOption = (index) => {
		setNewCheckBoxModal([true, index]);
		setNewOptionText('');
		newOptionForm.setFieldsValue({});
		newOptionForm.resetFields();
	};

	const handleNewCheckBoxModal = () => {
		// Create a new option object
		newOptionForm
			.validateFields()
			.then(() => {
				const newOption = {
					label: newOptionText,
					value: newOptionText,
				};

				if (
					newCheckBoxModal[1] !== null &&
					newCheckBoxModal[1] >= 0 &&
					newCheckBoxModal[1] < missingFields.length
				) {
					const updatedFields = [...missingFields];
					updatedFields[newCheckBoxModal[1]].options.push(newOption);
					setMissingFields(updatedFields);

					// Get the current form values
					const currentValues = missingFieldsForm.getFieldsValue();

					// Add the new option to the appropriate field and mark it as checked
					if (
						!currentValues[updatedFields[newCheckBoxModal[1]].name]
					) {
						currentValues[updatedFields[newCheckBoxModal[1]].name] =
							[];
					}
					currentValues[updatedFields[newCheckBoxModal[1]].name].push(
						newOptionText,
					);

					// Update the form with the new values
					missingFieldsForm.setFieldsValue(currentValues);
				}

				// Close the modal and reset the newOptionText state
				setNewCheckBoxModal([false, null]);
				setNewOptionText('');
				newOptionForm.setFieldsValue({});
				newOptionForm.resetFields();
			})
			.catch((info) => {
				console.log('Validate Failed:', info);
			});
	};

	const handleUploadCancel = () => {
		setIsClinicalUploadModalOpen(false);
		setClinicalDocumentFileList([]);
		setUpdatedClinicalDocumentFileList([]);
		setClinicalDocsLoading(false);
		setSubmitClinicalDocs(false);
		clinicalDocsForm.setFieldsValue({ clinical_docs: '' });
	};

	const handleClinicalDocsChange = ({ fileList: newFileList }) => {
		const updatedFileList = newFileList.map((file) => {
			if (file.status === 'error') {
				return { ...file, status: 'done' };
			}
			return file;
		});
		setClinicalDocumentFileList(updatedFileList);
		clinicalDocsForm.validateFields(['clinical_docs']);
	};

	const getTimeAgoOrDate = (updatedAt) => {
		const now = new Date();
		const updateDate = new Date(updatedAt);

		// Check if the updated date is today
		const isToday = now.toDateString() === updateDate.toDateString();

		if (isToday) {
			// Calculate time difference
			const diffInMs = now - updateDate;
			const seconds = Math.floor(diffInMs / 1000);
			const minutes = Math.floor(seconds / 60);
			const hours = Math.floor(minutes / 60);

			if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
			if (minutes > 0)
				return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
			return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
		} else {
			// If not today, return formatted date
			return updateDate.toLocaleDateString('en-GB'); // Format: DD/MM/YYYY
		}
	};

	useEffect(() => {
		if (submitClinicalDocs) {
			editCase({
				id: id,
				clinical_docs: updatedClinicalDocumentFileList,
				upload_documents: true,
				remove: true,
			});
		}
	}, [submitClinicalDocs]);

	// Handle missing fields submission
	const handleMissingFieldsSubmit = (values) => {
		// Store thank you message
		if (props.onUserInputRequired) {
			props.onUserInputRequired({
				response_type: 'text',
				response: 'Thank you for submitting the CPT codes.',
				action: 'analyze_case',
				component: 'case_analysis',
				parameters: {
					case_id: id,
					feedback_id: feedbackId,
					process_type: 'rc',
				},
				store_message: true,
			});
		}

		// // Add a small delay before starting reanalysis
		// setTimeout(() => {
		reviseCoverageReset();
		reviseCoverage({
			revenue_cycle: patientData.revenue_cycle,
			feedbackId: feedbackId,
			clinicalHistory: pageContent.pastHistory,
			presentComplaint: pageContent.presentComplaint,
			recommendedProcedure: pageContent.recommendedProcedure,
			medicalCoverage: pageContent.medicalCoverage,
			state: patientData.state,
			provider: patientData.insurance_company?.name,
			missing_fields: values,
			last_analysis_data: lastAnalysisData,
			supportingDocsSummary: patientData?.summary_docs,
			case_id: patientData._id,
		});

		missingFieldsForm.resetFields();
		setLoading(true);
		setCurrentView('loader');
		setAnalysisInProgress(true);
		setMissingFields([]);
		setMissingFieldInstructions([]);
		setMissingFieldsModal(false);
		setIsMissingFieldsThere(false);
		// }, 500);
	};

	// Handle send feedback
	const handleSendFeedback = (feedback, status, response) => {
		if (feedback === 'negative') {
			setLooksGoodLoading(true);
		} else {
			setCoverageLoading(true);
		}

		sendFeedback({
			feedback_id: feedbackId,
			feedback: feedback,
			status: status,
			response: response,
		});
	};

	// Handle reanalysis
	const handleReanalyze = () => {
		setLoading(true);
		setCurrentView('loader');
		setAnalysisInProgress(true);

		// Build the updated lastAnalysisData with current pageContent values
		const updatedLastAnalysisData = {
			...lastAnalysisData,
			'Past History': pageContent.pastHistory,
			'Present Complaint': pageContent.presentComplaint,
			'Suggested Treatment': pageContent.recommendedProcedure,
			'Medicare Evaluation': {
				...lastAnalysisData['Medicare Evaluation'],
				Coverage: pageContent.medicalCoverage[0],
				Rationale: pageContent.medicalCoverage[1],
				reference: pageContent.medicalCoverage[2],
			},
			original_query: pageContent.originalQuery,
			past_history: pageContent.pastHistory,
			present_complaint: pageContent.presentComplaint,
			status: pageContent.status,
			missing_points_for_coverage:
				pageContent.missing_points_for_coverage,
		};

		reviseCoverageReset();
		reviseCoverage({
			case_id: id,
			feedbackId: feedbackId,
			last_analysis_data: updatedLastAnalysisData,
			state: patientData?.state,
			provider: patientData?.insurance_company?.name,
			supportingDocsSummary: patientData?.summary_docs,
			revenue_cycle: patientData?.revenue_cycle,
		});
	};

	// Add this effect to handle view transitions after loading is complete
	useEffect(() => {
		if (
			!loading &&
			analysisCompleted === 'success' &&
			!isMissingFieldsThere
		) {
			// Loading is complete and analysis was successful with no missing fields
			setCurrentView(
				pageContent.status === 'approved'
					? 'case-details'
					: 'case-details',
			);
			setShowAnalysisData(true);
			setAnalysisInProgress(false);
			setAnalysisCompleted(''); // Reset for next time
		}
		// if (pageContent.status && pageContent.status !== 'approved') {
		// 	console.log(
		// 		'Creating user input request for coverage confirmation',
		// 	);

		// 	// Case is loaded and analyzed but not approved - ask user if they want to confirm coverage
		// 	const userInputRequest = {
		// 		response_type: 'user_input_required',
		// 		response: 'Do you want to confirm this case coverage?',
		// 		action: 'confirm_coverage',
		// 		component: 'case_analysis',
		// 		parameters: {
		// 			case_id: id,
		// 			feedback_id: feedbackId,
		// 			process_type: 'rc',
		// 		},
		// 		user_input: {
		// 			title: 'Would you like to confirm the coverage for this case?',
		// 			input_type: 'buttons',
		// 			parameter_key: 'confirm_coverage',
		// 			options: [
		// 				{
		// 					label: 'Yes, confirm coverage',
		// 					value: 'Yes, confirm coverage',
		// 				},
		// 				{ label: 'Not now', value: 'Not now' },
		// 			],
		// 		},
		// 	};

		// 	// Add some logging to troubleshoot
		// 	console.log(
		// 		'Sending user input request:',
		// 		userInputRequest,
		// 	);

		// 	// Pass this to the parent component through a callback
		// 	// if (props.onUserInputRequired) {
		// 	props.onUserInputRequired(userInputRequest);
		// 	// }
		// }
	}, [loading, analysisCompleted, isMissingFieldsThere, pageContent.status]);

	// Add this useEffect to handle the confirm_coverage action
	useEffect(() => {
		if (props.action === 'confirm_coverage' && props.actionParameters) {
			// Extract parameters
			const { case_id, feedback_id } = props.actionParameters;

			// Make sure we have the required parameters
			if (case_id && feedback_id) {
				// Call the sendFeedback function with positive feedback
				sendFeedback({
					feedback_id: feedback_id,
					feedback: null,
					status: 'approved',
					response: pageContent.medicalCoverage,
				});
			}
		}
	}, [props.action, props.actionParameters]);

	// // Add this effect to clean up messages when component unmounts or when analysis completes
	// useEffect(() => {
	// 	return () => {
	// 		// Clear any pending messages when component unmounts
	// 		if (props.onUserInputRequired) {
	// 			props.onUserInputRequired(null);
	// 		}
	// 	};
	// }, []);

	// Render different views based on current state
	const renderComponent = () => {
		switch (currentView) {
			case 'skeleton':
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<Skeleton active paragraph={{ rows: 6 }} />
						</div>
					</XThemeVoiceAssTableCard>
				);
			case 'loader':
				return (
					<VAAnalysisLoader
						analysisId={id}
						analysisCompleted={analysisCompleted}
						setAnalysisCompleted={setAnalysisCompleted}
						setLoading={setLoading}
						setCurrentView={setCurrentView}
						isMissingFieldsThere={isMissingFieldsThere}
						loading={loading}
						setIsMissingFieldsThere={setIsMissingFieldsThere}
					/>
				);
			case 'missing-fields':
				return (
					<VAMissingFields
						missingFields={missingFields}
						missingFieldInstructions={missingFieldInstructions}
						missingFieldTitle={missingFieldTitle}
						onSubmit={handleMissingFieldsSubmit}
						setMissingFields={setMissingFields}
						missingFieldsForm={missingFieldsForm}
						handleAddOption={handleAddOption}
						caseInfo={{
							patient_name: patientData?.patient_name,
							case_id: patientData?.case_id,
							mrn: patientData?.mrn,
						}}
					/>
				);
			case 'case-details':
				return (
					<VACaseDetails
						matchGender={matchGender}
						dateOfBirth={dateOfBirth}
						loading={loading}
						patientData={patientData}
						mainDataLoading={mainDataLoading}
						handleClinicalDocsChange={handleClinicalDocsChange}
						clinicalDocumentFileList={clinicalDocumentFileList}
						clinicalDocsForm={clinicalDocsForm}
						handleUploadCancel={handleUploadCancel}
						clinicalDocsLoading={clinicalDocsLoading}
						setIsClinicalUploadModalOpen={
							setIsClinicalUploadModalOpen
						}
						isClinicalUploadModalOpen={isClinicalUploadModalOpen}
						setPreviewImage={setPreviewImage}
						previewImage={previewImage}
						setPreviewTitle={setPreviewTitle}
						previewTitle={previewTitle}
						setPdfPreviewOpen={setPdfPreviewOpen}
						pdfPreviewOpen={pdfPreviewOpen}
						documentsToDisplay={documentsToDisplay}
						clinicalSummaryTextLoading={clinicalSummaryTextLoading}
						setClinicalSummaryTextLoading={
							setClinicalSummaryTextLoading
						}
						setShowClinicalTextArea={setShowClinicalTextArea}
						showClinicalTextArea={showClinicalTextArea}
						id={id}
						editCase={editCase}
						setPageContent={setPageContent}
						pageContent={pageContent}
						clinicalDocumentsToDisplay={clinicalDocumentsToDisplay}
						feedbackId={feedbackId}
						reviseCoverage={reviseCoverage}
						reviseCoverageReset={reviseCoverageReset}
						lastAnalysisData={lastAnalysisData}
						setLoading={setLoading}
						getBase64={getBase64}
						setClinicalDocsLoading={setClinicalDocsLoading}
						setSubmitClinicalDocs={setSubmitClinicalDocs}
						setUpdatedClinicalDocumentFileList={
							setUpdatedClinicalDocumentFileList
						}
						form={form}
						setModalTextArea={setModalTextArea}
						setModalOpen={setModalOpen}
						modalOpen={modalOpen}
						sendFeedback={sendFeedback}
						sendFeedbackState={sendFeedbackState}
						modalTextArea={modalTextArea}
						updatePageContent={updatePageContent}
						missingFieldsForm={missingFieldsForm}
						missingFieldsCardRef={missingFieldsCardRef}
						handleAddOption={handleAddOption}
						missingFields={missingFields}
						missingFieldInstructions={missingFieldInstructions}
						setMissingFieldsModal={setMissingFieldsModal}
						setMissingFieldInstructions={
							setMissingFieldInstructions
						}
						setMissingFields={setMissingFields}
						missingFieldTitle={missingFieldTitle}
						missingFieldsModal={missingFieldsModal}
						analysisData={lastAnalysisData}
						onSendFeedback={handleSendFeedback}
						onReanalyze={handleReanalyze}
						setCoverageLoading={setCoverageLoading}
						coverageloading={coverageloading}
						setLooksGoodLoading={setLooksGoodLoading}
						LooksGoodLoading={LooksGoodLoading}
						openedFromTable={openedFromTable}
						onBackToTable={props.onUserInputRequired}
						previousActionParameters={previousActionParameters}
					/>
				);
			case 'timeline_loader':
				return <VATimelineLoader analysisId={id} />;
			case 'case_timeline':
				return (
					<>
						{/* <VACaseDetails
							action={action}
							matchGender={matchGender}
							dateOfBirth={dateOfBirth}
							loading={loading}
							patientData={patientData}
							mainDataLoading={mainDataLoading}
							handleClinicalDocsChange={handleClinicalDocsChange}
							clinicalDocumentFileList={clinicalDocumentFileList}
							clinicalDocsForm={clinicalDocsForm}
							handleUploadCancel={handleUploadCancel}
							clinicalDocsLoading={clinicalDocsLoading}
							setIsClinicalUploadModalOpen={
								setIsClinicalUploadModalOpen
							}
							isClinicalUploadModalOpen={
								isClinicalUploadModalOpen
							}
							setPreviewImage={setPreviewImage}
							previewImage={previewImage}
							setPreviewTitle={setPreviewTitle}
							previewTitle={previewTitle}
							setPdfPreviewOpen={setPdfPreviewOpen}
							pdfPreviewOpen={pdfPreviewOpen}
							documentsToDisplay={documentsToDisplay}
							clinicalSummaryTextLoading={
								clinicalSummaryTextLoading
							}
							setClinicalSummaryTextLoading={
								setClinicalSummaryTextLoading
							}
							setShowClinicalTextArea={setShowClinicalTextArea}
							showClinicalTextArea={showClinicalTextArea}
							id={id}
							editCase={editCase}
							setPageContent={setPageContent}
							pageContent={pageContent}
							clinicalDocumentsToDisplay={
								clinicalDocumentsToDisplay
							}
							feedbackId={feedbackId}
							reviseCoverage={reviseCoverage}
							reviseCoverageReset={reviseCoverageReset}
							lastAnalysisData={lastAnalysisData}
							setLoading={setLoading}
							getBase64={getBase64}
							setClinicalDocsLoading={setClinicalDocsLoading}
							setSubmitClinicalDocs={setSubmitClinicalDocs}
							setUpdatedClinicalDocumentFileList={
								setUpdatedClinicalDocumentFileList
							}
							form={form}
							setModalTextArea={setModalTextArea}
							setModalOpen={setModalOpen}
							modalOpen={modalOpen}
							sendFeedback={sendFeedback}
							sendFeedbackState={sendFeedbackState}
							modalTextArea={modalTextArea}
							updatePageContent={updatePageContent}
							missingFieldsForm={missingFieldsForm}
							missingFieldsCardRef={missingFieldsCardRef}
							handleAddOption={handleAddOption}
							missingFields={missingFields}
							missingFieldInstructions={missingFieldInstructions}
							setMissingFieldsModal={setMissingFieldsModal}
							setMissingFieldInstructions={
								setMissingFieldInstructions
							}
							setMissingFields={setMissingFields}
							missingFieldTitle={missingFieldTitle}
							missingFieldsModal={missingFieldsModal}
							analysisData={lastAnalysisData}
							onSendFeedback={handleSendFeedback}
							onReanalyze={handleReanalyze}
							setCoverageLoading={setCoverageLoading}
							coverageloading={coverageloading}
							setLooksGoodLoading={setLooksGoodLoading}
							LooksGoodLoading={LooksGoodLoading}
						/> */}
						<VATimeline
							setCurrentActiveCollapse={setCurrentActiveCollapse}
							setPrevActiveCollapse={setPrevActiveCollapse}
							prevActiveCollapse={prevActiveCollapse}
							currentActiveCollapse={currentActiveCollapse}
							handlePreviewBeforUploa
							d={handlePreviewBeforUpload}
							handleChange={handleChange}
							handleDownload={handleDownload}
							selectedOption={selectedOption}
							filterByLabel={filterByLabel}
							denialReasonData={denialReasonData}
							handleSelect={handleSelect}
							handleDateChange={handleDateChange}
							disableFutureDates={disableFutureDates}
							updateModalOpen={updateModalOpen}
							updateForm={updateForm}
							handleSubmit={handleSubmit}
							patientData={patientData}
							handleInputChange={handleInputChange}
							setApproveModalOpen={setApproveModalOpen}
							revenueCycleStatus={revenueCycleStatus}
							setRevenueCycleStage={setRevenueCycleStage}
							revenueCycleStage={revenueCycleStage}
							status={formData?.status}
							setUpdateModalOpen={setUpdateModalOpen}
							setRevenueCycleStatus={setRevenueCycleStatus}
							revenueCycleFormData={revenueCycleFormData}
							setRevenueCycleFormData={setRevenueCycleFormData}
							timelineData={timelineData}
							togglePrepareLetter={togglePrepareLetter}
							setTogglePrepareLetter={setTogglePrepareLetter}
							fileList={fileList}
							setFileList={setFileList}
							setUpdatedFileList={setUpdatedFileList}
							updatedFileList={updatedFileList}
							id={id}
							setSelectedOption={setSelectedOption}
							medicareCoverage={pageContent.medicalCoverage[0]}
							case_status={patientData.status}
							setFlag={setFlag}
							setDownloadLoading={setDownloadLoading}
							updateModalButtonText={updateModalButtonText}
							updateCaseLoading={updateCaseLoading}
							viewAppealLetter={viewAppealLetter}
						/>
					</>
				);
			case 'error':
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<p>
								An error occurred while analyzing the case.
								Please try again later.
							</p>
						</div>
					</XThemeVoiceAssTableCard>
				);
			default:
				return (
					<XThemeVoiceAssTableCard>
						<div className="hasPadding">
							<Skeleton active paragraph={{ rows: 6 }} />
						</div>
					</XThemeVoiceAssTableCard>
				);
		}
	};

	return (
		<>
			{renderComponent()}
			{/* Modal for adding new option */}
			<XThemeModal
				title={
					<>
						<img
							className="img-fluid"
							src="/images/modal-add-title-icon.svg"
							alt=""
						/>
						<span className="ms-2">Add New Option</span>
					</>
				}
				open={newCheckBoxModal[0]}
				onOk={handleNewCheckBoxModal}
				okText="Submit"
				onCancel={() => {
					setNewCheckBoxModal([false, null]);
					setNewOptionText('');
					newOptionForm.setFieldsValue({});
					newOptionForm.resetFields();
				}}
				okButtonProps={{
					className: 'xThemeButtonSubmit',
				}}
				cancelButtonProps={{
					className: 'xThemeCancelSubmit',
				}}
			>
				<Row gutter={(15, 15)} className="mt-4">
					<Col xs={24}>
						<XThemeForm
							form={newOptionForm}
							name="groupForm"
							layout="vertical"
							autoComplete="off"
						>
							<XThemeForm.Item
								name={'new-option'}
								rules={[
									{
										required: true,
										message: 'Please input option',
									},
								]}
							>
								<XThemeInputText
									size="large"
									className="largeInputForms"
									value={newOptionText}
									onChange={(e) =>
										setNewOptionText(e.target.value)
									}
									placeholder="Enter new option text"
								/>
							</XThemeForm.Item>
						</XThemeForm>
					</Col>
				</Row>
			</XThemeModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	editCaseState: state.editCase,
	analyseCoverageState: state.analyseCoverage,
	reviseCoverageState: state.reviseCoverage,
	sendFeedbackState: state.sendFeedback,
	getAnalysisState: state.getAnalysis,
	getAnalysisStatusState: state.getAnalysisStatus,
	getAppealLetterState: state.getAppealLetter,
	saveAppealLetterState: state.saveAppealLetter,
	generateAppealLetterState: state.generateAppealLetter,
	getConfigurationsState: state.getConfigurations,
	getRevisionState: state.getRevision,
});

const mapDispatchToProps = (dispatch) => ({
	editCase: (data) => dispatch(editCaseApi(data)),
	editCaseReset: () => dispatch(editCaseReset()),
	analyseCoverage: (params) => dispatch(analyseCoverageApi(params)),
	analyseCoverageReset: () => dispatch(analyseCoverageReset()),
	reviseCoverage: (params) => dispatch(reviseCoverageApi(params)),
	reviseCoverageReset: () => dispatch(reviseCoverageReset()),
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: () => dispatch(getAnalysisReset()),
	sendFeedback: (params) => dispatch(sendFeedbackApi(params)),
	sendFeedbackReset: () => dispatch(sendFeedbackReset()),
	getAnalysisStatus: (params) => dispatch(getAnalysisStatusApi(params)),
	getAnalysisStatusReset: () => dispatch(getAnalysisStatusReset()),
	getAppealLetter: (params) => dispatch(getAppealLetterApi(params)),
	getAppealLetterReset: () => dispatch(getAppealLetterReset()),
	saveAppealLetter: (params) => dispatch(saveAppealLetterApi(params)),
	generateAppealLetter: (params) => dispatch(generateAppealLetterApi(params)),
	getConfigurations: (params) => dispatch(getConfigurationsApi(params)),
	getRevision: (params) => dispatch(getRevisionApi(params)),
	getRevisionReset: (params) => dispatch(getRevisionReset(params)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(VACaseAnalysisController);
